$ = require 'jquery'
Auth = require 'db/auth'
Browser = require 'lib/browser'
CardComposerInlineView = require 'views/card-composer/card-composer-inline-view'
{ maybeDisplayLimitsErrorOnCardAdd, canAddCard } = require 'views/card/card-limits-error'
CardListView = require 'views/card/card-list-view'
Controller = require 'controller'
require 'views/internal/data-transfer/drag-drop-events'
DragSort = require 'views/lib/drag-sort'
View = require 'views/internal/view'
ListMenuView = require 'views/list/list-menu-view'
PopOver = require 'views/lib/pop-over'
TrelloClipboard = require 'lib/trello-clipboard'
parseTrelloUrl = require 'lib/util/url/parse-trello-url'
parseUrl = require 'url-parse'
PluginRunner = require 'views/internal/plugins/plugin-runner'
Promise = require 'bluebird'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
_ = require 'underscore'
log = require 'debug/log'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
listTemplate = require 'views/templates/list'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
localizeCount = require 'lib/localize-count'
warnIfFileTooLarge = require 'views/internal/warn-if-file-too-large'
pastedFileName = require 'views/internal/pasted-file-name'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
l = require 'lib/localize'
f = require 'effing'
ninvoke = require 'lib/util/ninvoke'
removeAllRanges = require 'lib/util/removeAllRanges'

module.exports = class ListView extends View
  className: 'js-list list-wrapper'

  events:
    'mouseenter .js-open-list-menu': 'preloadMenu'
    'click .js-open-list-menu': 'openMenu'
    'mousedown .list-cards': 'eventStopPropagation'
    'click .js-open-card-composer': 'openCardComposer'

    'keydown  .js-list-name-input': 'keyDownEvent'
    'blur     .js-list-name-input': 'stopEditing'

    'click  .js-editing-target': 'startEditing'

    'movelist': 'moveList'

    'sortreceive': 'sortReceive'
    'sortcommit': 'sortCommit'

    'dd-drop:files': 'dropFiles'
    'dd-drop:text': 'dropText'
    'dd-drop:url': 'dropUrl'

    'mouseenter': 'mouseenter'
    'mouseleave': 'mouseleave'
    'mousemove': 'mousemove'
    'userinput-paste:text': 'dropText'
    'userinput-paste:files': 'dropFiles'
    'userinput-paste:url': 'dropUrl'

  initialize: ->
    super

    @fEditingName = false

    @makeDebouncedMethods 'toggleComposerLink', 'renderComposer'
      , 'renderCardCount', 'renderName', 'renderAddButton'

    @listenTo @model,
      'change:limits': @renderLimits
      'change:name': @renderNameDebounced
      'change:subscribed': @renderSubscribed

    @listenTo @model.cardList,
      'add remove change:idList change:closed reset': ->
        @renderCardCountDebounced()
        @renderAddButtonDebounced()

    @listenTo @model.getBoard(), 'permChange', @renderEditable

    @listenTo @model.getBoard().composer,
      'change:list change:index change:vis': @renderComposerDebounced
      'change:list change:vis': ->
        @toggleComposerLinkDebounced()

    @cardListView = @collectionSubview CardListView, @model.cardList,
      className: 'list-cards u-fancy-scrollbar u-clearfix js-list-cards'
      deferCards: @options.deferCards

    $(window).on "resize.#{@uniqueId()}", f(@, 'hackFlexboxForSadBrowsers')

    for eventName in ['mouseEnterCardView', 'mouseLeaveCardView', 'mouseMoveCardView']
      do (eventName) =>
        @listenTo @cardListView, eventName, (cardView) ->
          @trigger eventName, cardView

    return

  renderLimits: ->
    limited = !canAddCard({ destinationList: @model })
    @cardListView.$el.toggleClass 'card-limits-full', limited
    @

  render: ->
    log('render', "rendering list " + @model.get('name'))

    @cardListView.$el.detach()

    @$el.html listTemplate
      name: @model.get('name')
      subscribed: @model.get('subscribed')
      loggedIn: Auth.isLoggedIn()

    @cardListView.$el.insertAfter @$('.js-list-header')
    @cardListView.render()
    @cardListView.$el.toggleClass 'js-sortable', @model.editable()

    @renderLimits()

    @toggleComposerLinkDebounced()
    @renderComposerDebounced()

    @renderCardCount()
    @renderEditable()
    @renderAddButton()

    @hackFlexboxForSadBrowsers()

    # The short delay causes the UI thread to complete before calling autosize.
    # We'll call autosize in react's componentDidMount when it comes to this
    # view eventually.
    _.defer =>
      @$('.js-list-name-input').autosize(append: false)

    @

  remove: ->
    $(window).off ".#{@uniqueId()}"
    super

  renderName: ->

    @$('.js-list-name-assist').text(@model.get('name'))

    # don't update while your typing.
    if !@fEditingName

      @$('.js-list-name-input')
        .val(@model.get('name'))
        .trigger('autosize.resize', false)

    @

  renderSubscribed: ->
    @$('.js-list-subscribed').toggleClass('hide', !@model.get('subscribed'))
    @$('.js-list-header').toggleClass('is-subscribe-shown', @model.get('subscribed'))
    @$('.js-list-name-input').trigger('autosize.resize', false)
    @

  renderEditable: ->
    # NOTE: The best thing to do here is probably to toggle an 'editable' or
    # 'readonly' class on the $el, and use CSS to control the visibility of
    # things.  Not making this change because a lot of the templates are being
    # re-written.
    editable = @model.editable()

    @$('.js-list-cards').toggleClass('js-sortable', editable)

    if !editable
      @$('.js-list-name-input').attr('disabled', 'disabled')
    else
      @$('.js-list-name-input').removeAttr('disabled')

    @$('.js-open-card-composer').toggleClass('hide', !editable)

    DragSort.refreshListCardSortable()

    @

  hackFlexboxForSadBrowsers: ->
    if Browser.browserVersionStr !in ["explorer-10", "explorer-11"]
      return
    @defer =>
      $list = @$el
      listHeaderHeight = @$('.list-header').outerHeight()
      composerHeight = @$('.open-card-composer').outerHeight()
      boardHeight = $('#board').height()
      height = boardHeight - listHeaderHeight - composerHeight - 20
      @$('.list-cards').css('max-height': height)
    return

  saveListName: (e) ->
    $input = @$('.js-list-name-input')

    name = @model.get('name')
    newValue = $input.val()

    # remove new lines and extra whitespace
    newValue = newValue.replace(/\s+/g, ' ').trim()

    # if it's the same name, don't save
    if newValue == name
      return

    # if it's too long, don't save
    if newValue.length > 16384
      return

    # don't save if empty.
    if newValue.trim().length == 0
      return

    # We should handle the returned `err` someday…
    @model.update 'name', newValue

    return

  keyDownEvent: (e) ->

    if Keyboard.getKey(e) == Keys.Enter
      Util.stop(e) # prevents new lines.
      @stopEditing()
      return

    if Keyboard.getKey(e) == Keys.Escape
      @stopEditing()
      return

    return

  startEditing: (e) ->
    Util.stop(e)

    if !@fEditingName && !DragSort.sorting
      @fEditingName = true

      @$('.js-editing-target').addClass('is-hidden')

      _.defer =>
        @$('.js-list-name-input').focus().select().addClass('is-editing')

    return

  stopEditing: (e) ->

    if @fEditingName
      @$('.js-editing-target').removeClass('is-hidden')

      $input = @$('.js-list-name-input').removeClass('is-editing')
      if $input.is(":focus") then $input.blur()
      removeAllRanges()

      @fEditingName = false
      @saveListName()

    return

  toggleComposerLink: ->
    @$('.js-open-card-composer').toggleClass('hide', @composerOpen() || !@model.editable())

  composerOpen: ->
    composer = @model.getBoard()?.composer
    composer? && composer.get('vis') && composer.get('list') == @model

  renderComposer: ->

    if @composerOpen()
      composer = @model.getBoard().composer
      composerView = Controller.getCurrentBoardView().subview(CardComposerInlineView, composer)
      @insertComposerAtIndex(composer.get('index'), composerView)
      composerView.scrollIntoView()
      _.debounce(composerView.delegateEvents(), 150)

    @

  insertComposerAtIndex: (index, composerView) ->
    if index == 0
      @$('.list-cards').prepend(composerView.render().el)
    else
      cardIndex = index - 1
      $cards = @$('.list-card').not('.js-composer')
      if cardIndex >= $cards.length
        cardIndex = $cards.length - 1
      $cards.eq(cardIndex).after(composerView.render().el)
    return

  renderCardCount: ->
    @$('.js-num-cards').text localizeCount('cards', @model.openCards().length)

  openCardComposer: (e) ->
    Util.stop(e)

    PopOver.hide()

    board = @model.getBoard()
    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    board.composer.save({
      list: @model
      index: @model.openCards().length
      vis: true
    })

    track('Card Composer', 'Open', 'Via Bottom of List')

    return

  triggerOnItem: (e, ui, sEvent) ->
    Util.stopPropagation(e)

    # Don't kick off any re-renders until sortable puts the card in the DOM
    @defer => ui.item.trigger(sEvent, [ui, @])

    return

  sortReceive: (e, ui) ->
    @triggerOnItem(e, ui, 'moveto')
    return

  sortCommit: (e, ui) ->
    @triggerOnItem(e, ui, 'movein')
    return

  loadPluginActions: (target, timeout) ->
    PluginRunner.all
      timeout: timeout
      command: 'list-actions'
      el: target
      board: @model.getBoard()
      list: @model
    .catch  ->
      []
    .then (pluginActions) ->
      # limit to three actions per plugin
      _.chain(pluginActions)
        .groupBy('idPlugin')
        .map (val, idPlugin) -> val.slice(0, 3)
        .flatten()
        .value()

  preloadMenu: (e) ->
    if !DragSort.sorting && !@pluginActionsPromise?
      @pluginActionsPromise = @loadPluginActions(e.currentTarget, 500)
      .then (pluginActions) =>
        @pluginActionsPromise = null
        @pluginActions = pluginActions
        @pluginActionsExpiry = Date.now() + 5000
        return pluginActions

  openMenu: (e) ->
    view = @

    if (!DragSort.sorting)
      Util.preventDefault(e)

      track("List Menu", "Open List Menu")

      pluginActions = []

      if @pluginActions? && @pluginActionsExpiry > Date.now()
        pluginActions = @pluginActions
      else if @pluginActionsPromise?
        pluginActions = @pluginActionsPromise
      else
        pluginActions = @loadPluginActions(e.currentTarget, 150)

      Promise.resolve(pluginActions)
      .then (pluginActions) =>
        PopOver.toggle
          elem: e.currentTarget
          view: new ListMenuView({ @model, @modelCache, pluginActions })
        @pluginActions = null

      return false

    return

  moveList: (e, ui) ->
    Util.stop(e)
    lists = ui.item.parent().children()
    pos = lists.index(ui.item)
    @model.move(pos)
    return

  eventStopPropagation: (e) ->
    Util.stopPropagation(e)
    return

  scrollToCard: (card) ->
    cardView = @cardListView.viewForModel card
    Util.scrollElementIntoView @$('.js-list-cards')[0], cardView.el,
      vertical: true
      animated: true
    return

  mouseenter: (e) ->
    @trigger 'mouseEnterListView'
    UserInput.addHandler @, { scope: 'list' }

  mouseleave: (e) ->
    @trigger 'mouseLeaveListView'
    UserInput.removeHandler @, { scope: 'list' }

  mousemove: (e) ->
    @trigger 'mouseMoveListView'

  dropText: (e) ->
    if !@model.editable()
      return

    board = @model.getBoard()
    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
      hasAttachments: true,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    text = e.detail
    @model.uploadText(text)

  dropUrl: (e) ->
    if !@model.editable()
      return

    board = @model.getBoard()
    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
      hasAttachments: true,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    e.stopPropagation()
    url = e.detail

    if board.attachmentUrlRestricted(url)
      return

    parsedTrello = parseTrelloUrl(url)
    if parsedTrello.type == 'card'
        event = if TrelloClipboard.isCut(url) then 'moveCard' else 'copyCard'
        @trigger event,
          shortLink: parsedTrello.shortLink
          idList: @model.id
        return

    parsed = parseUrl(url)
    if (domain = parsed.host)?
      PluginRunner.one
        timeout: 2000
        command: 'card-from-url'
        list: @model
        board: @model.getBoard()
        options:
          url: url
      .catch PluginRunner.Error.NotHandled, ->
        {}
      .then (dataFromPlugin) =>
        placeholder = l('loading from domain', { domain })
        cardData = _.pick(dataFromPlugin, 'name', 'desc')
        if dataFromPlugin?.idPlugin
          trackUe('board view', 'creates', 'Power-Up', '', '', 'card-from-url', dataFromPlugin.idPlugin)
        ninvoke @model, 'uploadUrl', url, cardData, placeholder
      .done()

    return

  dropFiles: (e) ->
    if !@model.editable()
      return

    board = @model.getBoard()

    if board.attachmentTypeRestricted('computer')
      return

    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
      hasAttachments: true,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    files = e.detail

    if warnIfFileTooLarge(@model.getBoard(), files)
      return

    Promise.resolve(files)
    .each (file) =>
      name = file.name || pastedFileName()
      ninvoke @model, 'upload', file, name
    .catch(->)
    .done()

  renderAddButton: ->
    listIsEmpty =  @model.cardList.length == 0
    @$('.js-add-a-card').toggleClass('hide', !listIsEmpty)
    @$('.js-add-another-card').toggleClass('hide', listIsEmpty)
    # Design tweak that if there are cards, the plus icon should align
    # to the left edge of cards. If there aren't cards, it should align to title
    if !listIsEmpty
      @$('.open-card-composer').css('padding-left', '4px')



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-view.coffee